import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const LaneWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 20px;
  padding: 8px 16px;

  font-weight: 700;
  font-size: 16px;
  line-height: 20px;

  background-color: ${getToken('color-neutral-lighter')};
  border-radius: 4px;
`

function LaneBar(props) {
  const { origin = '', destination = '' } = props

  return (
    <LaneWrapper>
      <span>{origin}</span>
      <span>→</span>
      <span>{destination}</span>
    </LaneWrapper>
  )
}

LaneBar.propTypes = {
  origin: PropTypes.string,
  destination: PropTypes.string,
}

export { LaneBar }
